import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "leading-17 mb-8" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex text-sm font-bold mr-3 items-center" }
const _hoisted_4 = { class: "flex flex-1 flex-wrap leading-6 gap-3" }
const _hoisted_5 = { class: "flex pt-4" }
const _hoisted_6 = { class: "flex text-sm font-bold mr-3 items-center" }
const _hoisted_7 = { class: "flex flex-1 flex-wrap leading-6 gap-3" }
const _hoisted_8 = { class: "flex items-center mb-3" }
const _hoisted_9 = { class: "w-56" }
const _hoisted_10 = { class: "leading-8" }
const _hoisted_11 = { class: "flex-1 ml-5" }
const _hoisted_12 = { class: "flex mr-2" }
const _hoisted_13 = { class: "flex mr-2" }
const _hoisted_14 = { class: "border border-light-3 rounded-t-xl bg-light-3 align-middel h-14" }
const _hoisted_15 = { class: "flex items-center text-left text-dark-2 h-10 px-3 py-3 h-full" }
const _hoisted_16 = { class: "flex w-12 items-center" }
const _hoisted_17 = { class: "flex w-96 text-sm font-bold" }
const _hoisted_18 = { class: "flex w-96 text-sm font-bold" }
const _hoisted_19 = { class: "flex w-72 text-sm font-bold" }
const _hoisted_20 = { class: "flex w-72 text-sm font-bold" }
const _hoisted_21 = { class: "flex w-72 text-sm font-bold" }
const _hoisted_22 = { class: "flex w-72 text-sm font-bold" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex w-12 text-sm font-bold items-center" }, null, -1)
const _hoisted_24 = { class: "border-l border-r border-b border-light-3 overflow-hidden" }
const _hoisted_25 = { class: "flex w-12 items-center" }
const _hoisted_26 = { class: "flex w-96 items-center text-dark-2 font-medium" }
const _hoisted_27 = { class: "flex w-96 items-center text-dark-3" }
const _hoisted_28 = { class: "flex w-72 items-center text-dark-3" }
const _hoisted_29 = { class: "flex w-72 items-center text-dark-3" }
const _hoisted_30 = { class: "flex w-72 items-center text-dark-3" }
const _hoisted_31 = { class: "flex w-72 items-center text-dark-3" }
const _hoisted_32 = { class: "flex w-12" }
const _hoisted_33 = {
  key: 1,
  class: "h-100 flex items-center justify-center bg-white"
}
const _hoisted_34 = {
  width: 64,
  viewBox: "0 0 768 768",
  fill: "none"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("path", {
  class: "custom-loader-pulse",
  d: "M384 347.127L475.79 242H526V526H448.331V391.061L384 458.53L319.669 391.061V526H242V242H292.994L384 347.127Z"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("path", {
  class: "custom-loader-outline",
  d: "M384 347.127L475.79 242H526V526H448.331V391.061L384 458.53L319.669 391.061V526H242V242H292.994L384 347.127Z"
}, null, -1)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = {
  key: 2,
  class: "h-100 flex items-center justify-center bg-white"
}
const _hoisted_39 = { class: "bg-light-2" }
const _hoisted_40 = { class: "flex items-center justify-center text-dark-3 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_card_filter = _resolveComponent("card-filter")!
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_download_excel = _resolveComponent("download-excel")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_paginator = _resolveComponent("paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_section, { class: "pt-5 bg-light-2" }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("pages.contacts.header")), 1),
        _createVNode(_component_card_filter, {
          title: _ctx.$t('pages.contacts.segments'),
          class: "mb-8",
          onCollapse: _ctx.toggleSegmentFilterCollapsed
        }, _createSlots({ _: 2 }, [
          (_ctx.segmentFilterCollapsed)
            ? {
                name: "header",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.activeSegmentFilter !== ""
                        ? _ctx.activeSegmentFilter
                        : _ctx.$t("pages.contacts.allContacts")), 1)
                ]),
                key: "0"
              }
            : undefined,
          (!_ctx.segmentFilterCollapsed)
            ? {
                name: "content",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("pages.contacts.systemSegments")), 1),
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemSegments, (segment) => {
                        return (_openBlock(), _createBlock(_component_app_button, {
                          key: segment.id,
                          class: "",
                          "button-style": 
                                segment.alias === _ctx.activeSegmentFilter
                                    ? 'whiteActive'
                                    : 'white'
                            ,
                          onClick: ($event: any) => (_ctx.applySegmentFilter(segment.alias))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(segment.publicName ?? segment.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["button-style", "onClick"]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("pages.contacts.yourSegments")), 1),
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userSegments, (segment) => {
                        return (_openBlock(), _createBlock(_component_app_button, {
                          key: segment.id,
                          class: "",
                          "button-style": 
                                segment.alias === _ctx.activeSegmentFilter
                                    ? 'whiteActive'
                                    : 'white'
                            ,
                          onClick: ($event: any) => (_ctx.applySegmentFilter(segment.alias))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(segment.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["button-style", "onClick"]))
                      }), 128))
                    ])
                  ])
                ]),
                key: "1"
              }
            : undefined
        ]), 1032, ["title", "onCollapse"]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("pages.contacts.contactList.header", {
                            count: _ctx.contactsCounts,
                            total: _ctx.totalContacts
                        })), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_app_search, {
              modelValue: _ctx.dynamicContactsSearch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dynamicContactsSearch) = $event)),
              class: "w-100 mr-6",
              placeholder: "Search"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_download_excel, {
              data: 
                        _ctx.selectedContacts.length
                            ? _ctx.dynamicContactList.filter(({ id }) =>
                                  _ctx.selectedContacts.includes(id)
                              )
                            : _ctx.dynamicContactList
                    ,
              type: "csv",
              name: `contacts-${new Date().toISOString()}.csv`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_button, { "button-style": "transparent" }, {
                  left: _withCtx(() => [
                    _createVNode(_component_app_icon, {
                      name: "Download",
                      size: "5"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("pages.contacts.exportContacts")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "name"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_app_button, {
              "button-style": "transparent",
              onClick: _ctx.exportSubscriptions
            }, {
              left: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  name: "Download",
                  size: "5"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.$t("pages.contacts.exportSubscriptions")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_ctx.dynamicContactList.length)
                ? (_openBlock(), _createBlock(_component_checkbox, {
                    key: 0,
                    modelValue: _ctx.selectAllContacts,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectAllContacts) = $event)),
                    binary: true
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("pages.contacts.contactList.nameHeader")), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("pages.contacts.contactList.emailHeader")), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("pages.contacts.contactList.ordersHeader")), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("pages.contacts.contactList.cltvHeader")), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("pages.contacts.contactList.createdHeader")), 1),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("pages.contacts.contactList.lastActiveHeader")), 1),
            _hoisted_23
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, { class: "pb-24" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", null, [
            (_ctx.dynamicContactList.length && !_ctx.loadingContacts)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dynamicContactList, (contact) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: contact.id,
                    class: "flex text-sm px-3 py-3 bg-white border-b hover:bg-light-1 group"
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_checkbox, {
                        name: "selected-contacts",
                        modelValue: _ctx.selectedContacts,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedContacts) = $event)),
                        value: contact.id
                      }, null, 8, ["modelValue", "value"])
                    ]),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(contact.fullName), 1),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(contact.email), 1),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.getLeadStat(contact.id, "totalNumberOrders")), 1),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.getLeadStat(contact.id, "totalOrderValue")
                                    ? `${_ctx.currency} ${_ctx.getLeadStat(
                                          contact.id,
                                          "totalOrderValue"
                                      ).toFixed(2)}`
                                    : ""), 1),
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.date2relative(contact.dateIdentified)), 1),
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.date2relative(contact.lastActive)), 1),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_app_icon, {
                        name: "ExternalLink",
                        size: "4",
                        onClick: ($event: any) => (_ctx.openContactDetails(contact.id)),
                        class: "hidden group-hover:block mr-1 text-dark-3 cursor-pointer"
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              : (_ctx.loadingContacts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_34, _hoisted_37))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("pages.contacts.contactList.noContacts")), 1)
                  ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_paginator, {
            first: _ctx.contactFirst,
            "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactFirst) = $event)),
            rows: _ctx.rows,
            "onUpdate:rows": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rows) = $event)),
            totalRecords: _ctx.contactsCounts,
            rowsPerPageOptions: [10, 20, 50, 100, 200]
          }, null, 8, ["first", "rows", "totalRecords"])
        ]),
        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("pages.contacts.contactList.footer", {
                    from: _ctx.contactFirstFooter,
                    to: _ctx.contactEndFooter,
                    total: _ctx.contactsCounts
                })), 1)
      ]),
      _: 1
    })
  ], 64))
}